export const POST_SALES_LISTING = "POST_SALES_LISTING";
export const SITE_INSPECTION_LISTING = "SITE_INSPECTION_LISTING";
export const INSPECTION_CREATED = "INSPECTION_CREATED";
